module.exports = __webpack_public_path__ + "static/media/italy.b2e5530b.png";